// Is a screen still arriving?
//
// The top progress bar used to be a fixed animation: it filled in half a second
// and faded, whatever the page was doing. On a slow link a chunk can take ten
// seconds, so the bar finished long before the screen arrived and the app
// looked frozen - the complaint was "10 second tak wahi screen khuli rehti".
//
// This is the smallest possible bridge between the two: whatever is standing in
// for a screen that has not arrived (RouteSkeleton) says so here, and the bar
// reads it. No context, no provider, no re-render of the tree - a counter and a
// set of listeners, because the bar is the only thing that cares.
let waiting = 0;
const listeners = new Set();

const emit = () => {
  listeners.forEach((fn) => {
    try {
      fn(waiting > 0);
    } catch {
      /* a broken listener must not stop the others */
    }
  });
};

// Called on mount / unmount of a placeholder. Counted, not a boolean, because
// two placeholders can overlap (an outer gate and an inner route).
export function beginRouteWait() {
  waiting += 1;
  emit();
}

export function endRouteWait() {
  waiting = Math.max(0, waiting - 1);
  emit();
}

export function isRouteWaiting() {
  return waiting > 0;
}

// Returns the unsubscribe function, so an effect can just return it.
export function subscribeRouteWait(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
